import { Action } from '@ngrx/store';

import { MapPosition } from '../models';

export enum MapActionTypes {
  SAVE_MAP_POSITION = '[Map] Save Map Position',
  CLEAR_MAP_POSITION = '[Map] Clear Map Position',
}

export class SaveMapPositionAction implements Action {
  readonly type = MapActionTypes.SAVE_MAP_POSITION;
  constructor(public mapId: string, public position: Partial<MapPosition>) {}
}

export class ClearMapPositionAction implements Action {
  readonly type = MapActionTypes.CLEAR_MAP_POSITION;
  constructor(public mapId?: string) {}
}

export type MapAction = SaveMapPositionAction | ClearMapPositionAction;
